const CampusResources = () => import(/* webpackChunkName: "gt-campus" */'@/components/CampusResources/Index')
const CampusResourcesVideo = () => import(/* webpackChunkName: "gt-campus-view" */'@/components/CampusResources/CampusResourcesVideo')
const CampusResource = () => import(/* webpackChunkName: "gt-campus-view" */'@/components/CampusResources/CampusResource')
const CampusEvents = () => import(/* webpackChunkName: "gt-campus-events" */'@/components/CampusResources/CampusEvents/CampusEvents')

export default [
    {
        path: '/campus-resources/',
        component: CampusResources,
        children: [{

            path: '/',
            name: 'campus-resources-video',
            component: CampusResourcesVideo

        }, {
            path: 'campus-events',
            name: 'events',
            component: CampusEvents,
            // children: [{
            //     path: ':event',
            //     name: 'event',
            //     props: true,
            //     component: CampusEvents
            // }
            // ]
        }, {

            path: ':slug',
            name: 'resource',
            props: true,
            component: CampusResource

        }]
    }
]